import { FC } from 'react';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import useSlideIcons from '@/util/slideIcons.ts';
import { translate } from '@/translation/translate.ts';

interface CustomOverlayNavigationProps {
  shareButtonWasClicked: boolean;
}

export const CustomOverlayNavigation: FC<CustomOverlayNavigationProps> = ({ shareButtonWasClicked }) => {
  const { next, currentSlide } = useNavigation();
  const { nextIcon } = useSlideIcons(currentSlide!);

  const nextLabel = shareButtonWasClicked
    ? translate(currentSlide?.nextLabelSuccess)
    : translate(currentSlide?.nextLabelNormal);

  return (
    <div className="Navigation forceshow">
      <button className="nav-next" onClick={next}>
        {nextLabel}
        <i className={nextIcon} />
      </button>
    </div>
  );
};
